/** Límites de las leyendas del pie del PDF; los mismos que valida el backend. */
export const MAX_LEYENDAS = 20;
export const MAX_LARGO_LEYENDA = 1000;

/** Una leyenda vacía o solo con espacios no se puede guardar. */
export const leyendaVacia = (leyenda: string): boolean => leyenda.trim() === '';

export const leyendasValidas = (leyendas: string[]): boolean =>
  leyendas.length <= MAX_LEYENDAS &&
  leyendas.every((leyenda) => !leyendaVacia(leyenda) && leyenda.length <= MAX_LARGO_LEYENDA);
